import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

/** Shared fallback for the initial shell and subsequent route chunks. */
export function RouteLoading() {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label="Loading page"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        minHeight: "40vh",
        p: 3,
      }}
    >
      <CircularProgress size={28} aria-hidden="true" />
      <Typography color="text.secondary">Loading page…</Typography>
    </Box>
  );
}
